import { render, staticRenderFns } from "./TipsOneLineText.vue?vue&type=template&id=bb9d4884&scoped=true&lang=pug"
import script from "./TipsOneLineText.vue?vue&type=script&lang=js"
export * from "./TipsOneLineText.vue?vue&type=script&lang=js"
import style0 from "./TipsOneLineText.vue?vue&type=style&index=0&id=bb9d4884&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9d4884",
  null
  
)

export default component.exports